import * as React from 'react';
import classNames from 'classnames';

import { IGalleryLabel } from '../../types/gallery-label';
import * as styles from './GalleryLabels.css';

interface IGalleryLabelsProps {
  labels: IGalleryLabel[];
  hasFeatures: boolean;
}

export const GalleryLabels = ({ labels, hasFeatures }: IGalleryLabelsProps) => {
  return (
    <div className={classNames(styles['container'], hasFeatures && styles['has-features'])}>
      {labels.map(({ label, color }) => (
        <div key={label} className={classNames(styles['label'], styles[`${color}-label`])}>
          {label}
        </div>
      ))}
    </div>
  );
};
